type OperationLabels = {
  [key: string]: string;
};

export const operationLabels: OperationLabels = {
  ADD_PARTNER: 'AddPartner',
  CONSTITUTION: 'Constitution',
  CAPITAL_INCREASE: 'CapitalIncrease',
  CAPITAL_DECREASE: 'CapitalDecrease',
  SELL_PARTICIPATION: 'SELL_PARTICIPATION',
  HERITAGE: 'Heritage',
  DONATION: 'Donation',
  TRANSMISSION: 'Transmission',
  SPLIT: 'Split',
  RENUMERATION: 'Renumeration',
  RECLASSIFICATION: 'Reclassification',
  DIVIDENDS_DISTRIBUTION: 'DividendsDistribution',
  CONTRIBUTION: 'OtherContributions',
  ENDORSEMENT: 'Endorsement',
};
